enum MysteryPacksQA {
  MysteryPackGrailShowcase = 'MysteryPackGrailShowcase',
  MysteryPackGrailOdds = 'MysteryPackGrailOdds',
  MysteryPackGrailItem = 'MysteryPackGrailItem',
  MysteryPackGrailItemName = 'MysteryPackGrailItemName',
  MysteryPackGrailItemValue = 'MysteryPackGrailItemValue',
  MysteryPackPriceLevelSelector = 'MysteryPackPriceLevelSelector',
  MysteryPackPriceLevelCard = 'MysteryPackPriceLevelCard',
  MysteryPackPriceLevelLabel = 'MysteryPackPriceLevelLabel',
  MysteryPackPriceLevelSoldOut = 'MysteryPackPriceLevelSoldOut',
  MysteryPackHowItWorks = 'MysteryPackHowItWorks',
  MysteryPackHowItWorksStep = 'MysteryPackHowItWorksStep',
  MysteryPackFaqs = 'MysteryPackFaqs',
  MysteryPackFaq = 'MysteryPackFaq',
  MysteryPackFaqQuestion = 'MysteryPackFaqQuestion',
  MysteryPackFaqAnswer = 'MysteryPackFaqAnswer',
  MysteryPackFaqOpenIcon = 'MysteryPackFaqOpenIcon',
  MysteryPackFaqCloseIcon = 'MysteryPackFaqCloseIcon',
  MysteryPackOddsSection = 'MysteryPackOddsSection',
  MysteryPackOddsHeading = 'MysteryPackOddsHeading',
  MysteryPackOddsCard = 'MysteryPackOddsCard',
  MysteryPackEstimatedValueAverage = 'MysteryPackEstimatedValueAverage',
  MysteryPackEstimatedValueTop = 'MysteryPackEstimatedValueTop',
  MysteryPackOddsBand = 'MysteryPackOddsBand',
  MysteryPackOddsBandLabel = 'MysteryPackOddsBandLabel',
  MysteryPackOddsBandPercent = 'MysteryPackOddsBandPercent',
  MysteryPackOddsDisclaimer = 'MysteryPackOddsDisclaimer',
}

export default MysteryPacksQA
